import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserRegistration } from "@/components/UserRegistration";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HeroVideoSection } from "@/components/HeroVideoSection";
import { ThreePillarsSection } from "@/components/ThreePillarsSection";
import { ClubPortalSection } from "@/components/ClubPortalSection";
import { HowWeDoItSection } from "@/components/HowWeDoItSection";
import { GlobalMetricsSection } from "@/components/GlobalMetricsSection";
import { ParentFAQSection } from "@/components/ParentFAQSection";
import { FutWorkCTA } from "@/components/FutWorkCTA";
import { StickyMobileCTA } from "@/components/StickyMobileCTA";
import { ScrollProgressDots } from "@/components/ScrollProgressDots";
import stadiumHazeBg from "@/assets/stadium-haze-bg.jpg";

const Index = () => {
  const navigate = useNavigate();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem('soccer-registered-user');
    if (savedUser) {
      try {
        const parsedUser = JSON.parse(savedUser);
        if (parsedUser.playerId && parsedUser.jerseyNumber) {
          console.log('Registered user found, redirecting to player train');
          setIsRedirecting(true);
          navigate('/player/train', { replace: true });
          return;
        }
      } catch {
        localStorage.removeItem('soccer-registered-user');
      }
    }
  }, [navigate]);

  if (isRedirecting) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-foreground text-xl">Redirecting to dashboard...</div>
      </div>
    );
  }

  const handleRegistrationComplete = (userData: any) => {
    console.log('Registration completed, redirecting to player train');
    localStorage.setItem('soccer-registered-user', JSON.stringify(userData));
    navigate('/player/train', { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Header />
      <ScrollProgressDots />
      
      {/* 1. Hero — Benefit-first messaging */}
      <div id="hero">
        <HeroVideoSection />
      </div>

      {/* 2. Three Pillars — Tabbed, compact */}
      <ThreePillarsSection />

      {/* 3. Training Levels Carousel */}
      <div id="training">
        <HowWeDoItSection />
      </div>

      {/* 4. Coach & Club Portal */}
      <ClubPortalSection />
      
      {/* 5. Social Proof & Highlights */}
      <div id="results">
        <GlobalMetricsSection />
      </div>

      {/* 6. Parent FAQ */}
      <div id="faq">
        <ParentFAQSection />
      </div>
      
      {/* 7. CTA Banner */}
      <section className="py-6 md:py-10 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          <FutWorkCTA />
        </div>
      </section>
      
      {/* 8. Sign In Section — Stadium Haze Immersive */}
      <section 
        id="sign-in"
        className="relative py-16 md:py-24 overflow-hidden min-h-[80vh] flex items-center"
        style={{ background: 'hsl(224 54% 6%)' }}
      >
        {/* Stadium haze background */}
        <div className="absolute inset-0">
          <img 
            src={stadiumHazeBg} 
            alt="" 
            className="w-full h-full object-cover opacity-40 blur-sm"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[hsl(224_54%_6%)] via-transparent to-[hsl(224_54%_6%)/0.8]" />
        </div>
        
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-sm md:max-w-md mx-auto">
            <UserRegistration onRegistrationComplete={handleRegistrationComplete} />
          </div>
        </div>
      </section>
      
      <Footer />

      {/* Sticky Mobile CTA */}
      <StickyMobileCTA />
    </div>
  );
};

export default Index;
